import axios from 'axios';

import cfac22 from '../cfac22';

export function getCardByIdNode(cardId) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      get(cfac22('API_HOST_V2') + `/cards/getCardById/?cardId=${cardId}`, {
        headers: { 'Full-Url': window.location.href }, withCredentials: true
      }).
      then((result) => {
        resolve(result.data.result);
      }).
      catch((error) => {
        return reject(error.data.error);
      });
    }).
    catch((error) => {
      reject(error);
    });
  });
}
